module.exports = __webpack_public_path__ + "static/media/kpi.c32bc57f.png";